import { getProtected, postProtected } from './utils';

/**
 * Gets a summary of the players current balance / reserved balance on his main currency wallet
 * @param {string} playerSessionID
 * @param {(null|'casino'|'bingo')} product Can be null, casino or bingo
 */
export var getWallet = function getWallet(playerSessionID, product) {
  if (!product) {
    return getProtected('/wallet', playerSessionID);
  }

  return getProtected('/wallet?product=' + product, playerSessionID);
};

/**
 * Gets a summary of the players current balance / reserved balance per currency
 * @param {string} playerSessionID
 * @param {(null|'casino'|'bingo')} product Can be null, casino or bingo
 */
export var getWallets = function getWallets(playerSessionID, product) {
  if (!product) {
    return getProtected('/wallets', playerSessionID);
  }

  return getProtected('/wallets?product=' + product, playerSessionID);
};

/**
 * Set's the players active currency, all transactions will be made against the wallets in this currency, if no wallet is currently setup for this currency then one will be created
 * @param {string} playerSessionID
 * @param {string} currency
 */
export var setWallet = function setWallet(playerSessionID, currency) {
  return postProtected('/wallet?currency=' + currency, playerSessionID);
};

/**
 * Gets a summary of the players current balance / reserved balance for a specific currency.
 * @param {string} playerSessionID
 * @param {string} currency Currency to retrieve balance for
 * @param {(null|'casino'|'bingo')} [product] Can be null, casino or bingo
 */
export var getByCurrency = function getByCurrency(playerSessionID, currency, product) {
  if (!product) {
    return getProtected('/wallet/' + currency, playerSessionID);
  }

  return getProtected('/wallet/' + currency + '?product=' + product, playerSessionID);
};

export default {
  getWallet: getWallet,
  setWallet: setWallet,
  getWallets: getWallets,
  getByCurrency: getByCurrency
};